import { useCallback, useEffect, useState } from 'react';
import AssigneeCell from './AssigneeCell';
import { TaskRow, STATUS_LABEL, dateLabel, plannedRange, propertyLabel, getJson } from './types';

import { tx } from '../../../lib/adminI18n';
// 清掃管理ダッシュボード（最初に開くタブ）  手順5
//   毎朝「今日の作業状況」「清掃漏れ」「要確認」を短時間で確認するための画面。
interface Dash {
  date: string; tomorrow: string; week_end: string;
  counts: { today: number; today_done: number; tomorrow: number; overdue: number; review: number; unassigned_week: number };
  today_tasks: TaskRow[]; tomorrow_tasks: TaskRow[]; week_tasks: TaskRow[]; overdue_tasks: TaskRow[]; review_tasks: TaskRow[];
}

export default function CleaningDashboard({ onOpenDate, onOpenUnassigned }: {
  onOpenDate: (ymd: string) => void; onOpenUnassigned: () => void;
}) {
  const [d, setD] = useState<Dash | null>(null);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setError('');
    try { setD(await getJson('/api/admin/cleaning/dashboard')); }
    catch (e: any) { setError(e.message); }
  }, []);
  useEffect(() => { void load(); }, [load]);

  if (error) return <p className="cln-msg cln-msg-error">⚠ {error}</p>;
  if (!d) return <p>{tx('clnD.0')}</p>;
  const k = d.counts;

  return (
    <div className="cdash">
      <div className="cdash-head">
        <span>{tx('clnD.1')}</span>
        <button className="cln-btn cln-btn-ghost" onClick={() => void load()}>{tx('clnD.2')}</button>
      </div>
      <div className="cdash-cards">
        <div className="cdash-card cdash-card-static">
          <span className="cdash-label">{tx('clnD.3')}</span>
          <span className="cdash-num">{k.today}<small>{tx('clnD.4')}</small></span>
          <span className="cdash-sub">{tx('clnD.5')} {k.today_done} {tx('clnD.6')} {k.today - k.today_done}</span>
        </div>
        <a className={`cdash-card ${k.overdue ? 'warn' : ''}`} href="#cdash-overdue">
          <span className="cdash-label">{tx('clnD.7')}</span>
          <span className="cdash-num">{k.overdue}<small>{tx('clnD.4')}</small></span>
          <span className="cdash-sub">{tx('clnD.8')}</span>
        </a>
        <a className={`cdash-card ${k.review ? 'alert' : ''}`} href="#cdash-review">
          <span className="cdash-label">{tx('clnD.9')}</span>
          <span className="cdash-num">{k.review}<small>{tx('clnD.4')}</small></span>
          <span className="cdash-sub">{tx('clnD.10')}</span>
        </a>
        <button type="button" className={`cdash-card ${k.unassigned_week ? 'warn' : ''}`} onClick={onOpenUnassigned}>
          <span className="cdash-label">{tx('clnD.11')}</span>
          <span className="cdash-num">{k.unassigned_week}<small>{tx('clnD.4')}</small></span>
          <span className="cdash-sub">{tx('clnD.12')}</span>
        </button>
        <a className="cdash-card" href="#cdash-week">
          <span className="cdash-label">{tx('clnD.13')}</span>
          <span className="cdash-num">{k.tomorrow}<small>{tx('clnD.4')}</small></span>
          <span className="cdash-sub">{dateLabel(d.tomorrow)}</span>
        </a>
      </div>

      {d.overdue_tasks.length > 0 && (
        <Section id="cdash-overdue" title={tx('clnD.14')} tasks={d.overdue_tasks} onOpenDate={onOpenDate} showDate empty="" />
      )}
      {d.review_tasks.length > 0 && (
        <Section id="cdash-review" title={tx('clnD.15')} tasks={d.review_tasks} onOpenDate={onOpenDate} showDate showReason empty="" />
      )}
      <Section id="cdash-week" title={tx('clnD.16', { p0: dateLabel(d.tomorrow), p1: dateLabel(d.week_end) })} tasks={d.week_tasks} onOpenDate={onOpenDate} showDate empty={tx('clnD.17')} />
      <p className="clm-note">{tx('clnD.18')}</p>
    </div>
  );
}

function Section({ id, title, tasks, onOpenDate, empty, showDate, showReason }: {
  id: string; title: string; tasks: TaskRow[]; onOpenDate: (ymd: string) => void;
  empty: string; showDate?: boolean; showReason?: boolean;
}) {
  return (
    <section id={id} className="cdash-section">
      <h2>{title}<span className="cdash-count">{tasks.length}{tx('clnD.4')}</span></h2>
      {tasks.length === 0 ? <p className="cln-detail-empty">{empty}</p> : (
        <table className="ctl-table">
          <thead>
            <tr>{showDate && <th>{tx('clnD.19')}</th>}<th>{tx('clnD.20')}</th><th>{tx('clnD.21')}</th><th>{tx('clnD.22')}</th><th>{tx('clnD.23')}</th></tr>
          </thead>
          <tbody>
            {tasks.map((t) => (
              <tr key={t.id} className={`ctl-row ${t.status}`} onClick={() => onOpenDate(t.cleaning_date)}>
                {showDate && <td data-label={tx('clnD.19')}>{dateLabel(t.cleaning_date)}</td>}
                <td data-label={tx('clnD.20')}>{propertyLabel(t)}</td>
                <td data-label={tx('clnD.21')}><AssigneeCell t={t} /></td>
                <td data-label={tx('clnD.22')}>{plannedRange(t)}</td>
                <td data-label={tx('clnD.23')}>
                  <span className={`cln-status cln-status-${t.status}`}>{STATUS_LABEL[t.status] || t.status}</span>
                  {showReason && t.issue_reason && <div className="ctl-reason">{t.issue_reason.split('\n')[0]}</div>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
